import React from 'react'
import cx from 'classnames'
import { AvatarRound } from '@manychat/manyui'

import cm from './styles.module.css'

interface CommentProps {
  avatar: string | null
  comment: React.ReactNode
  variant: 'default' | 'light'
}

export const Comment = ({ avatar, comment, variant }: CommentProps) => (
  <article
    className={cx(cm.comment, {
      [cm.comment_light]: variant === 'light',
    })}
  >
    <AvatarRound src={avatar ?? ''} className={cm.comment__avatar} alt="" />

    <p className={cm.comment__content}>
      <span role="presentation">{comment}</span>
    </p>
  </article>
)
